export default __webpack_public_path__ + "static/media/cafeHero.55cdf19b.jpg";